import Link from '@/components/Link'
import { ListItemText, MenuItem, Typography } from '@mui/material'

import { usePopupState, bindHover, bindMenu } from 'material-ui-popup-state/hooks'
import HoverMenu from 'material-ui-popup-state/HoverMenu'
import React from 'react'

const DropdownLinks: React.FC<{
  id: string
  label: string
  links: { name: string; color?: string; url: string; newTab?: boolean }[]
  dataCy?: string
  sx?: React.CSSProperties
}> = ({ id, label, links, dataCy, sx }) => {
  const popupState = usePopupState({
    variant: 'popover',
    popupId: `${id}-dropdown`,
  })

  return (
    <div data-cy={dataCy} style={sx}>
      <Typography
        color={popupState.isOpen ? 'primary' : 'text.secondary'}
        style={{ cursor: 'pointer' }}
        noWrap
        {...bindHover(popupState)}>
        {label}
      </Typography>
      <HoverMenu
        {...bindMenu(popupState)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{
          '.MuiMenu-paper': {
            borderTopColor: 'primary.main',
            borderBottomColor: 'primary.main',
            borderTopWidth: 4,
            borderBottomWidth: 4,
            borderTopStyle: 'solid',
            borderBottomStyle: 'solid',
          },
          '.MuiList-root': {
            padding: 0,
          },
        }}>
        {links.map((link, i) => (
          <Link
            key={link.name}
            passHref
            href={link.url}
            style={{ textDecoration: 'none' }}
            target={link.newTab ? '_blank' : undefined}
            rel={link.newTab ? 'noopener noreferrer' : undefined}>
            <MenuItem
              sx={{
                py: 2,
                px: 4,
                borderBottomWidth: links.length - 1 !== i ? 1 : 0,
                borderBottomStyle: 'solid',
                borderBottomColor: 'divider',
              }}>
              <ListItemText
                primaryTypographyProps={{
                  color: link.color || 'text.secondary',
                  textAlign: 'center',
                }}>
                {link.name}
              </ListItemText>
            </MenuItem>
          </Link>
        ))}
      </HoverMenu>
    </div>
  )
}

export default DropdownLinks
